'use client';
import IconButton from './IconButton';
import SortItem from './SortItem';
import useSortFilter from './useSortFilter';
import Popover from '@/external/components/Popover';
import { CasinoGameConnectionSorter } from '@/schema';

type Props = {
  isMobile: boolean;
  isBitcasino: boolean;
  sortParams: string | undefined;
  options: {
    value: keyof CasinoGameConnectionSorter;
    label: string;
  }[];
};

const SortPopover: FC<Props> = ({
  isMobile,
  options,
  isBitcasino,
  sortParams,
}) => {
  const { handleSelect, sort } = useSortFilter(sortParams);
  const value = options.find((item) => item.value === sort.name)?.label;
  return (
    <Popover position="bottom-end">
      <Popover.Trigger>
        <IconButton fullWidth={isMobile}>{value}</IconButton>
      </Popover.Trigger>
      <Popover.Panel className="w-60 p-3">
        {options.map((item) => (
          <SortItem
            key={item.value}
            current={sort}
            item={item}
            onSortSelect={handleSelect}
            isBitcasino={isBitcasino}
          />
        ))}
      </Popover.Panel>
    </Popover>
  );
};
export default SortPopover;
